import React from 'react'
import { useDropzone } from 'react-dropzone'
import { ReactComponent as UploadIcon } from 'assets/icons/add_file.svg'
import styles from 'components/Shared/Dropzone/Dropzone.module.css'
import { useTranslation } from 'react-i18next'

export function Dropzone ({ files, onDrop, chipRenderer, chipContainerStyles, disabled, label }) {
  const { t } = useTranslation()

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: 'image/*, application/pdf',
    onDrop,
    disabled
  })

  return (
    <div>
      <div disabled={disabled} className={styles.container} {...getRootProps()}>
        <input {...getInputProps()} />
        {
          <div>
            <UploadIcon disabled={disabled} className={styles.uploadIcon}/>
            {t(isDragActive ? 'form.dropzone.hover' : (label? label:'form.dropzone.name'))}
          </div>
        }
      </div>
      <div className={chipContainerStyles ? chipContainerStyles : styles.fileChipRow}>
        <ul>
          {files.map(chipRenderer)}
        </ul>
      </div>
    </div>
  )
}
